export default "__VITE_ASSET__e83e9299__"